import { Injectable } from '@angular/core';
import { RestApiService } from '../../../common/rest-api/services/rest-api.service'; 
import { WebOrder } from '../models/web-order.model';
import { RouteComment } from '../models/route-comment.model';


@Injectable({
  providedIn: 'root',
})
export class SystemSettingService extends RestApiService<WebOrder> {

  protected resourcePath = '/system-settings';



  async getSystemAdminDetail(): Promise<any> {

    const url = this.buildEndpointUrl(`system-admin`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
   async updateSystemAdminDetail(settingAdmin:any): Promise<any> {

    const url = this.buildEndpointUrl(`system-admin/update`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
      body:settingAdmin
    }, 'POST');
    
    return response;
  }
   async updateHandheldSystemAdmin(settingAdmin:any): Promise<any> {

    const url = this.buildEndpointUrl(`system-admin/handheld/update`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
      body:settingAdmin
    }, 'POST');
    
    return response;
  }
  async getHandheldAdminDetail(): Promise<any> {

    const url = this.buildEndpointUrl(`system-admin/handheld/get`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
    async getRouteComment(): Promise<any> {

    const url = this.buildEndpointUrl(`route-comment/get`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
  async updateRouteComment(settingAdmin:RouteComment[]): Promise<string> {

    const url = this.buildEndpointUrl(`route-comment/update`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
      body:settingAdmin
    }, 'POST');
    
    return response;
  }
  

  async getCustomerProductDetail(customerCode:string): Promise<any> {
     let url='';
    if(customerCode==""){
        url = this.buildEndpointUrl(`customer-product`);
      }else{
        url = this.buildEndpointUrl(`customer-product/${customerCode}`);
      }
    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
  async saveCustomerSettings(customerCode:string,selectedPayMethods:any,selectedOrderTypes:any): Promise<any> {
    const payload = {
        customerCode: customerCode,
        payMethods: selectedPayMethods,
        orderTypes: selectedOrderTypes
      };
       let url = this.buildEndpointUrl(`customer-product/save`);
    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
      body: payload
    }, 'POST');
    
    return response;
  }
    async getWebOrderType(): Promise<any> {
          const url = this.buildEndpointUrl(`web-order-type/list`);
    
    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
  async updateWebOrderTypes(webOrderTypes:any): Promise<any> {
       let url = this.buildEndpointUrl(`web-order-type/update`);
    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
      body: webOrderTypes
    }, 'POST');
    
    return response;
  }
    async  getWebOrderSteps(typeCode:string): Promise<any> {
        const url = this.buildEndpointUrl(`web-order-type/steps/${typeCode}`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
 
    async updateWebOrderSteps(webOrderTypeSteps:any): Promise<any> {
       let url = this.buildEndpointUrl(`web-order-type/steps/update`);
    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
      body: webOrderTypeSteps
    }, 'POST');
    return response;
  }
     async  getCustomerSiteReports(userType:string): Promise<any> {
        const url = this.buildEndpointUrl(`customer-site-reports/get/${userType}`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
    async  getCustomerSiteReportsByQuery(id:string): Promise<any> {
        const url = this.buildEndpointUrl(`customer-site-reports/getQuery/${id}`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    return response;
  }
      async  getCustomerSiteAdmin(): Promise<any> {
        const url = this.buildEndpointUrl(`customer-site-admin/get`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    return response;
  }
  
   async  getCustomSiteReportById(id:number): Promise<any> {
    
        const url = this.buildEndpointUrl(`customer-site-admin/edit/${id}`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    return response;
  }

   async  saveCustomSiteAdmin(webReport:any): Promise<any> {
    
        const url = this.buildEndpointUrl(`customer-site-admin/update`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
      body:webReport
    }, 'POST');
    return response;
  }
    async  deleteCustomSiteAdmin(id:number): Promise<any> {
    
        const url = this.buildEndpointUrl(`customer-site-admin/delete/${id}`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
    }, 'DELETE');
    return response;
  }
 del
}